import { createContext, useContext } from 'react';
// "as unknown as Comet" is used because we really don't need defaultValue
export const CometContext = createContext(undefined);
export function useCometContext() {
    return useContext(CometContext);
}
